import { useAtom, useSetAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const posOrderTipAtom = atomWithStorage<string>("posOrderTipAtom", "-1");

const usePosOrderTipAtom = () => {
  const atom = useAtom(posOrderTipAtom);
  return atom;
};

export const useSetPosOrderTip = () => useSetAtom(posOrderTipAtom);

export default usePosOrderTipAtom;
